/*!

 =========================================================
 * Vue Black Dashboard PRO - v1.2.1
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-kit-pro
 * Copyright 2019 Creative Tim (https://www.creative-tim.com)

 * Coded by Creative Tim

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import RouterPrefetch from 'vue-router-prefetch'
import DashboardPlugin from 'src/util/plugins/dashboard-plugin';
import App from './App.vue';
import VueProgressBar from "vue-progressbar";
import store from "./vuex/index";
import router from "src/http/router";
import Router from "vue-router";
import i18n from './i18n';
import './registerServiceWorker'
import VueMask from 'v-mask'
import money from 'v-money'
import roleAndPermissionPlugin from "src/util/plugins/roleAndPermissionPlugin";
import Skeleton from 'vue-loading-skeleton';
import PrettyCheckbox from 'pretty-checkbox-vue';
import VueApexCharts from 'vue-apexcharts'
import VeeValidate, { Validator } from 'vee-validate';
import PtBr from 'vee-validate/dist/locale/pt_BR';
import Loading from 'vue-loading-overlay';
import "vue-loading-overlay/dist/vue-loading.css";
import VuePapaParse from "vue-papa-parse";
import directives from "./directives"

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueRouter);
Vue.use(RouterPrefetch);
Vue.use(require('vue-moment'));
Vue.use(VueMask);
Vue.use(Router);
Vue.use(money, {precision: 4})
Vue.use(roleAndPermissionPlugin);
Vue.use(Skeleton);
Vue.use(PrettyCheckbox);
Vue.use(Loading);
Vue.component('apexchart', VueApexCharts)
Vue.use(VuePapaParse)
Vue.use(directives)

Vue.use(VueProgressBar, {
  color: "#ff854d",
  failedColor: "#ec0d0d",
  thickness: "3px",
  autoFinish: false
});

Vue.use(VeeValidate);

Validator.localize('pt_BR', PtBr);

Validator.extend('corporate_email', {
  validate: (value) => {
    const blockedDomains = ['gmail.com', 'outlook.com', 'yahoo.com', 'hotmail.com'];
    const domain = value.split('@')[1];
    return !blockedDomains.includes(domain);
  },
  getMessage: () => 'Por favor, use um email corporativo.',
});

/* eslint-disable no-new */
let vue = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
});
window.App = vue;
vue.$mount("#app");


export default vue;
